import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stats-panel" }
const _hoisted_2 = { class: "card bg-light" }
const _hoisted_3 = {
  id: "card-body-expanded",
  class: "card-body"
}
const _hoisted_4 = { class: "todays-steps grid-cell" }
const _hoisted_5 = { class: "progress-row" }
const _hoisted_6 = { class: "progress-col-bar mt-1" }
const _hoisted_7 = { class: "progress" }
const _hoisted_8 = ["aria-valuenow"]
const _hoisted_9 = { class: "progress-col-number" }
const _hoisted_10 = { class: "total-steps grid-cell position-relative" }
const _hoisted_11 = { class: "center-section-header" }
const _hoisted_12 = { class: "total-steps-main-content" }
const _hoisted_13 = { class: "icon-row" }
const _hoisted_14 = { class: "steps-popover position-absolute rounded text-light" }
const _hoisted_15 = { class: "popover-row" }
const _hoisted_16 = { class: "row-header text-muted" }
const _hoisted_17 = { class: "calculation-blocks my-2 d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "block p-2 d-flex flex-column justify-content-space-evenly rounded" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "operator text-light" }, " + ", -1)
const _hoisted_20 = { class: "block p-2 d-flex flex-column justify-content-space-evenly rounded" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "operator text-light" }, " = ", -1)
const _hoisted_22 = { class: "block p-2 d-flex flex-column justify-content-space-evenly rounded" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "popover-row" }
const _hoisted_26 = { class: "row-header text-muted" }
const _hoisted_27 = { class: "calculation-blocks my-2 d-flex align-items-center justify-content-start" }
const _hoisted_28 = { class: "block p-2 d-flex flex-column justify-content-space-evenly rounded" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "current-streak grid-cell" }
const _hoisted_31 = { class: "center-section-header" }
const _hoisted_32 = { class: "icon-row collapse" }
const _hoisted_33 = {
  key: 0,
  alt: "Streak icon",
  src: "/media/icons/flame.png",
  class: "current-streak-icon"
}
const _hoisted_34 = {
  key: 1,
  alt: "Streak icon",
  src: "/media/icons/streak-icon-inactive.svg",
  class: "current-streak-icon"
}
const _hoisted_35 = { class: "genres-read grid-cell" }
const _hoisted_36 = { class: "milestone-medals grid-cell" }
const _hoisted_37 = { class: "current-streak milestone-cell grid-cell" }
const _hoisted_38 = { class: "center-section-header" }
const _hoisted_39 = { class: "icon-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_genre_chart = _resolveComponent("genre-chart")!
  const _component_milestone_bar = _resolveComponent("milestone-bar")!
  const _component_milestone_badge = _resolveComponent("milestone-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('statsPanel.todaysSteps')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    "aria-valuenow": $options.stepsToday,
                    "aria-valuemin": "0",
                    "aria-valuemax": "4",
                    style: _normalizeStyle({ 'width': $options.stepsTodayWidth }),
                    "aria-label": "Reading Steps Progress Bar"
                  }, null, 12, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", {
                  style: _normalizeStyle({'opacity': $options.stepsToday >= 4 ? '100%' : '35%'})
                }, _toDisplayString($options.stepsToday) + " / 4 ", 5)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('statsPanel.totalSteps')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_inline_svg, {
                src: require('/public/media/icons/steps-icon.svg'),
                style: _normalizeStyle({fill: $options.stepsTotal > 4 ? '#007BEC' : 'none'}),
                class: "total-steps-icon"
              }, null, 8, ["src", "style"]),
              _createElementVNode("p", {
                style: _normalizeStyle({color: $options.stepsTotal > 0 ? '#007BEC' : 'none'})
              }, _toDisplayString($options.stepsTotal), 5)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.$t('statsPanel.schoolYear')) + " " + _toDisplayString($options.currentSchoolYearName), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('statsPanel.approved')), 1),
                    _createElementVNode("p", null, _toDisplayString($options.stepsTotal - $options.stepsAwaitingApproval), 1)
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('statsPanel.unapproved')), 1),
                    _createElementVNode("p", null, _toDisplayString($options.stepsAwaitingApproval), 1)
                  ]),
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('statsPanel.totalSteps')), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_inline_svg, {
                        src: require('/public/media/icons/steps-icon-white.svg'),
                        class: "total-steps-icon me-2"
                      }, null, 8, ["src"]),
                      _createElementVNode("p", null, _toDisplayString($options.stepsTotal), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t('statsPanel.sinceSchoolYear')) + " " + _toDisplayString($options.initialSchoolYearName), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('statsPanel.lifetimeSteps')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_inline_svg, {
                        src: require('/public/media/icons/lifetime-steps-icon.svg'),
                        class: "total-steps-icon me-2"
                      }, null, 8, ["src"]),
                      _createElementVNode("p", null, _toDisplayString($options.lifetimeSteps), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('statsPanel.currentStreak')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_32, [
              ($options.stepsToday >= 4)
                ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                : ($options.stepsToday < 4)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                  : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: "streak-number",
                style: _normalizeStyle({color: $options.stepsToday >= 4 ? 'rgb(238,128,49)' : '#999'})
              }, _toDisplayString($options.streak.current), 5)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('statsPanel.genresRead')), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_genre_chart)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('statsPanel.milestoneMedals')), 1),
          _createElementVNode("div", {
            class: _normalizeClass($data.collapseMedals == true ? 'collapse' : 'collapse.show')
          }, [
            _createVNode(_component_milestone_bar, { steps: $options.stepsTotal }, null, 8, ["steps"])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('statsPanel.milestone')), 1),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_milestone_badge, {
              stepNumber: Math.round($options.stepsTotal/100)*100,
              totalSteps: $options.stepsTotal
            }, null, 8, ["stepNumber", "totalSteps"])
          ])
        ])
      ])
    ])
  ]))
}